/**
 * Plain Link wrapper for tracking only,
 * No style is applied
 */

import { Link } from 'gatsby';
import type { GatsbyLinkProps } from 'gatsby';
import React, { HTMLProps, useRef } from 'react';
import { trackButtonActivity } from 'src/functions/propagateQueryParams';

export const LinkPlainInternal = ({ children, ...props }: React.PropsWithoutRef<GatsbyLinkProps<any>>): JSX.Element => {
  const buttonRef = useRef<any>();

  // Extend onClick listener for Trackers, etc.
  const trackOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    trackButtonActivity(buttonRef.current);
    if (props.onClick) {
      props.onClick(e);
    }
    return true;
  };

  return (
    <Link
      {...props}
      onClick={trackOnClick}
      ref={buttonRef}
    >
      {children}
    </Link>
  );
};

export const LinkPlainExternal = (props: HTMLProps<HTMLAnchorElement>): JSX.Element => {
  const buttonRef = useRef<HTMLAnchorElement>();

  // Extend onClick listener for Trackers, etc.
  const trackOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    trackButtonActivity(buttonRef.current);
    if (props.onClick) {
      props.onClick(e);
    }
    return true;
  };

  return (
    <a
      {...props}
      ref={buttonRef}
      onClick={trackOnClick}
    >
      {props.children}
    </a>
  );
};
